import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["isMobile", "collapsed"];
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { ArrowSvgIcon } from '../SiderMenu/Arrow';
import { useStyle } from './style';
export var CollapsedIcon = function CollapsedIcon(props) {
  var _classNames;

  var isMobile = props.isMobile,
      collapsed = props.collapsed,
      rest = _objectWithoutProperties(props, _excluded);

  var _useStyle = useStyle(props.className),
      wrapSSR = _useStyle.wrapSSR,
      hashId = _useStyle.hashId;

  if (isMobile && collapsed) return null;
  return wrapSSR(_jsx("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: classNames(props.className, hashId, (_classNames = {}, _defineProperty(_classNames, "".concat(props.className, "-collapsed"), collapsed), _defineProperty(_classNames, "".concat(props.className, "-is-mobile"), isMobile), _classNames)),
    children: _jsx(ArrowSvgIcon, {})
  })));
};